"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotItemInputRoleEnum = void 0;
exports.instanceOfChatbotItemInput = instanceOfChatbotItemInput;
exports.ChatbotItemInputFromJSON = ChatbotItemInputFromJSON;
exports.ChatbotItemInputFromJSONTyped = ChatbotItemInputFromJSONTyped;
exports.ChatbotItemInputToJSON = ChatbotItemInputToJSON;
/**
 * @export
 */
exports.ChatbotItemInputRoleEnum = {
    User: 'user',
    Chatbots: 'chatbots'
};
/**
 * Check if a given object implements the ChatbotItemInput interface.
 */
function instanceOfChatbotItemInput(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('role' in value) || value['role'] === undefined)
        return false;
    return true;
}
function ChatbotItemInputFromJSON(json) {
    return ChatbotItemInputFromJSONTyped(json, false);
}
function ChatbotItemInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'],
        'role': json['role'],
    };
}
function ChatbotItemInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'role': value['role'],
    };
}
